import { Row, Col, Label } from "reactstrap"
import Flatpickr from "react-flatpickr"
import Select from "react-select"

const VehicleMovementFilter = ({
  filters,
  setFilters,
  movementTypes = [],
  movementByOptions = [],
  locationOptions = [],
  loading,
  compact = false,
}) => {
  // In a narrow container (e.g. the stock view tab) viewport breakpoints
  // still see a wide screen, so `sm={2}` would squeeze each field. Use
  // wider fractions there so filters wrap into readable rows instead.
  const colProps = compact
    ? { xs: 12, sm: 6, md: 4 }
    : { sm: 2 }


  const handleDateChange = (selectedDates, name) => {
    if (name === "range") {
      setFilters(prev => ({
        ...prev,
        date_from: selectedDates[0] ? formatDate(selectedDates[0]) : "",
        date_to: selectedDates[1] ? formatDate(selectedDates[1]) : "",
      }))
    } else {
      setFilters(prev => ({
        ...prev,
        date_from: selectedDates[0] ? formatDate(selectedDates[0]) : "",
        date_to: "",
      }))
    }
  }

  const formatDate = date => {
    const d = new Date(date)
    const month = `${d.getMonth() + 1}`.padStart(2, "0")
    const day = `${d.getDate()}`.padStart(2, "0")
    const year = d.getFullYear()
    return `${year}-${month}-${day}`
  }

  return (
    <div className="border p-3 rounded bg-light">
      <Row className="align-items-end">
        {/* Location */}
        <Col {...colProps} className="mb-3">
          <Label>Last Location</Label>
          <Select
            options={locationOptions}
            value={
              locationOptions.find(
                o => o.value === Number(filters?.location_to_id)
              ) || null
            }
            onChange={selected =>
              setFilters(prev => ({
                ...prev,
                location_to_id: selected ? selected.value : "",
              }))
            }
            isClearable
            placeholder="Select Type"
          />
        </Col>
        {/* Movement Type */}
        <Col {...colProps} className="mb-3">
          <Label>Movement Type</Label>
          <Select
            options={movementTypes}
            value={
              movementTypes.find(
                o => o.value === Number(filters.movement_type_id)
              ) || null
            }
            onChange={selected =>
              setFilters(prev => ({
                ...prev,
                movement_type_id: selected ? selected.value : "",
              }))
            }
            isClearable
            placeholder="Select Type"
          />
        </Col>
        <Col {...colProps} className="mb-3">
          <Label>Movement By</Label>
          <Select
            options={movementByOptions}
            value={
              movementByOptions.find(
                o => o.value === Number(filters.movement_by_id)
              ) || null
            }
            onChange={selected =>
              setFilters(prev => ({
                ...prev,
                movement_by_id: selected ? selected.value : "",
              }))
            }
            isClearable
            placeholder="Select a staff"
          />
        </Col>

        {/* From Date */}
        <Col {...colProps} className="mb-3">
          <Label>From Date</Label>
          <Flatpickr
            value={filters.date_from || ""}
            onChange={dates => handleDateChange(dates, "single")}
            options={{
              dateFormat: "Y-m-d",
              altInput: true,
              altFormat: "F j, Y",
            }}
            className="form-control"
            placeholder="Select start date"
          />
        </Col>

        {/* To Date */}
        <Col {...colProps} className="mb-3">
          <Label>To Date</Label>
          <Flatpickr
            value={filters.date_to || ""}
            onChange={dates =>
              setFilters(prev => ({
                ...prev,
                date_to: dates[0] ? formatDate(dates[0]) : "",
              }))
            }
            options={{
              dateFormat: "Y-m-d",
              altInput: true,
              altFormat: "F j, Y",
              minDate: filters.date_from || null,
            }}
            className="form-control"
            placeholder="Select end date"
          />
        </Col>
      </Row>
    </div>
  )
}

export default VehicleMovementFilter
